import script from "./ApplicationStatusPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApplicationStatusPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ApplicationStatusPanel.vue?vue&type=style&index=0&id=63cfa979&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cfa979"]])

export default __exports__